import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import axios from 'axios';
import { BASE_URL } from "../../App";
import { FaDownload } from "react-icons/fa6";
import { IoCloudUploadOutline } from "react-icons/io5";
import Swal from 'sweetalert2'
import { FaFileDownload } from "react-icons/fa";
import NoData from "../image/no_data.jpg";


const ExcelReader = () => {
  const navigate = useNavigate();
  const [excelData, setExcelData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false); // Loading state
  const [Imgshow, setImgshow] = useState(false); // Loading state
  const fileInputRef = useRef(null);
  const location = useLocation();


  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get('branch');
    if (id !== '1702') {
        Swal.fire({
          icon: 'warning',
          title: "warning",
          text: "Authenticator Error",
        }).then(() => {
          navigate(-1);
          return;
        });
    }
}, []);


  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    setImgshow(false);
  };


  const handleFileUpload = () => {
    setExcelData([]);
    if (selectedFile) {
      setLoading(true); // Start loading
      const reader = new FileReader();


      reader.onload = async (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet);


        const data1 = { file_upload: jsonData };


        try {
          const response = await axios.post(BASE_URL + '/excel_upload', data1, {
            headers: {
              'Content-Type': 'application/json',
            },
          });


          // if(response.data.files_data != ""){


            setExcelData(response.data.files_data);
            setImgshow(true);
          // } else {
// 
            // Swal.fire({
            //   title: "warning",
            //   text: "No Data Available",
            //   icon: "warning"
            // });


          // }
          console.log("API Response:", response.data);
          //alert("Data uploaded successfully!");
        } catch (error) {
          console.error('Error uploading data:', error);
          // alert('Error uploading data. Please try again.');
          Swal.fire({
            title: "warning",
            text: "Error uploading data. Please try again.",
            icon: "error"
          });
        } finally {
          setLoading(false); // Stop loading
        }


        // Clear the file input after successful upload
        fileInputRef.current.value = '';
        setSelectedFile(null);
      };


      reader.readAsArrayBuffer(selectedFile);
    } else {
      alert("Please select a file first.");
    }
  };


  const downloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");


    // Create a download link and trigger it
    XLSX.writeFile(wb, "happy_code.xlsx");
  };


  const sampledownloadExcel = () => {
    const sampleData = [
      { TokenNumber: '001'},
      { TokenNumber: '002'},
      // Add more sample rows as needed
    ];


    const ws = XLSX.utils.json_to_sheet(sampleData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sample Data");
    XLSX.writeFile(wb, "Sample_Template.xlsx");
  }


  const css = `
    /* From Uiverse.io by satyamchaudharydev */ 
    .spinner {
      --size-of-spinner: 50px;
      --spinner-border-width: 4px;
      --spinner-color: #08c18a;
      --circle-color: #8bc34a24;
      --speed-of-animation: 2s;
      --scale: 1.3;
      width: var(--size-of-spinner);
      height: var(--size-of-spinner);
      background: var(--circle-color);
      border-radius: 50%;
      position: relative;
    }


    .spinner::after {
      content: "";
      display: block;
      position: absolute;
      border-radius: 50%;
      inset: 0;
      border: var(--spinner-border-width) solid var(--spinner-color);
      border-left-color: transparent;
      border-right-color: transparent;
      animation: spinny var(--speed-of-animation) linear infinite;
    }


    @keyframes spinny {
      0% {
        transform: rotate(0deg) scale(1)
      }


      50% {
        transform: rotate(45deg) scale(var(--scale))
      }


      100% {
        transform: rotate(360deg) scale(1)
      }
    }
  `;


  return (
    <div className="container mt-5">
      <style>{css}</style>
      <div className="mb-4 d-flex justify-content-around align-items-center">
  <h2 className="text-center mx-auto"><u>Upload Excel File</u></h2>
  <div>
    <button className="btn btn-success btn-sm" onClick={sampledownloadExcel}>
      <FaFileDownload size={15} /> Download Sample Template
    </button>
  </div>
</div>
      <div className="mb-3">
        <div className="row">
          <div className="col-6">
            <input
              type="file"
              className="form-control"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
              ref={fileInputRef}
            />
          </div>
          <div className="col-6">
            <button
              className="btn btn-primary"
              onClick={handleFileUpload}
              style={{ width: "70%" }}
            >
              <IoCloudUploadOutline size={20} /> Upload
            </button>
          </div>
        </div>
      </div>
      {loading && (
        <div className="mt-10">
        <center>
          <div className="spinner"></div>
        </center>
        </div>
      )}
      {/* {excelData.length > 0 && ( */}
      {excelData.length > 0 ? (
        <div className="mb-4"> 
          <div className="d-flex justify-content-end">
            <button className="btn btn-success btn-sm" onClick={downloadExcel}>
              <FaDownload size={15} /> Download Excel
            </button>
          </div>
          <table className="table table-striped table-bordered">
            <thead className="table-success">
              <tr className="bg-success">
                {Object.keys(excelData[0]).map((key) => (
                  <th className="bg-success" key={key}>{key === 'TokenNumber' ? 'Token Number' :
                    key === 'HappyCode' ? 'Happy Code' : 
                    key === 'UnHappyCode' ? 'UnHappy Code': key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {excelData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {Object.values(row).map((value, colIndex) => (
                    <td key={colIndex}>{value}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <>
        {Imgshow && (
          <div className="text-center">
          <img src={NoData} alt="No Data" className="img-fluid" />
        </div>
        )}
        </>
      )}
    {/* )} */}
    </div>
  );
};


export default ExcelReader;
